(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-iframe-communication.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-iframe-communication.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.accountservices.iamPostMessage.logger;
const _svs$accountservices$ = svs.accountservices.iamPostMessage,
  POST_MESSAGE_SOURCES = _svs$accountservices$.POST_MESSAGE_SOURCES,
  POST_MESSAGE_TYPES = _svs$accountservices$.POST_MESSAGE_TYPES,
  isOriginTrusted = _svs$accountservices$.isOriginTrusted,
  generateRequestId = _svs$accountservices$.generateRequestId;

const noopLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {}
};

class IamIframeCommunication {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.source = options.source || POST_MESSAGE_SOURCES.IFRAME;
    this.logger = options.logger || logger || noopLogger;
    this.isInIframe = window.self !== window.top;
    this.messageHandlers = new Map();
    this.parentOrigin = null; 
  }

  isInsideIframe() {
    return this.isInIframe;
  }

  sendToParent(message) {
    if (!this.isInIframe) {
      this.logger.warn('Not in iframe, cannot send message to parent');
      return false;
    }
    if (!Object.values(POST_MESSAGE_TYPES).includes(message.type)) {
      this.logger.error('Invalid message type:', message.type);
      return false;
    }
    const payload = _objectSpread(_objectSpread({}, message), {}, {
      source: this.source,
      messageType: message.type,
      type: undefined 
    });

    const targetOrigin = this.parentOrigin || '*';
    window.parent.postMessage(payload, targetOrigin);
    return true;
  }

  sendToParentAndWait(message, responseType) {
    let timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
    return new Promise((resolve, reject) => {
      if (!this.isInIframe) {
        reject(new Error('Not in iframe'));
        return;
      }
      const requestId = generateRequestId();
      let resolved = false;
      let timeoutId;
      const handleResponse = event => {
        if (!event.origin || !isOriginTrusted(event)) {
          return;
        }
        if (event.data && event.data.source === POST_MESSAGE_SOURCES.PARENT && event.data.requestId === requestId && event.data.messageType === responseType) {
          if (!this.parentOrigin) {
            this.parentOrigin = event.origin;
          }
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          window.removeEventListener('message', handleResponse);
          resolved = true;
          resolve(event.data.value);
        }
      };
      window.addEventListener('message', handleResponse);

      this.sendToParent(_objectSpread(_objectSpread({}, message), {}, {
        requestId
      }));

      if (timeout > 0) {
        timeoutId = setTimeout(() => {
          if (!resolved) {
            window.removeEventListener('message', handleResponse);
            reject(new Error("Timeout waiting for response type: ".concat(responseType)));
          }
        }, timeout);
      }
    });
  }

  listenToParent(callback) {
    const handler = event => {
      if (!event.origin || !isOriginTrusted(event)) {
        this.logger.warn('Received postMessage from untrusted origin', event.origin);
        return;
      }
      const data = event && event.data;

      if (!data || typeof data !== 'object' || data.source !== POST_MESSAGE_SOURCES.PARENT || !Object.values(POST_MESSAGE_TYPES).includes(data.messageType)) {
        this.logger.debug('Ignoring postMessage with unexpected format or source', data);
        return;
      }

      if (!this.parentOrigin) {
        this.parentOrigin = event.origin;
        this.logger.debug('Cached parent origin:', this.parentOrigin);
      }
      callback(event, data);
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }
}

svs.accountservices.iamPostMessage.IamIframeCommunication = IamIframeCommunication;

 })(window);